import type { OpenAPI } from "../../interfaces"

export const notifications = (api) => ({
  get(page: number, success: OpenAPI.GET<"/notifications">["response"], fail) {
    api.authenticatedRequest("GET", `/notifications?page=${page}`, null, success, fail)
  },
  markAsSeen(notificationIds, markAllAsSeen, success, fail) {
    api.authenticatedRequest(
      "PUT",
      `/notifications/seen`,
      { notifications: notificationIds, markAllAsSeen },
      success,
      fail,
    )
  },
  markAsInteracted(notification, success, fail) {
    api.authenticatedRequest("PUT", `/notifications/${notification}/interacted`, null, success, fail)
  },
})
